import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import {OrganisationLabelListContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class OrganisationLabelListService extends BaseApiPublicLoginTemplateService<OrganisationLabelListContainerModel, OrganisationLabelListContainerModel, OrganisationLabelListContainerModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'financial-organization-labels';
  static readonly LABEL_LIST_SUB_PATH = 'label-lists/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'financial-organization-labels';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'financial-organization-labels';
    this.httpClient = http;
  }
}
